import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Paper,
  TablePagination,
} from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import { API_ENDPOINTS, BASE_URL } from "../../Utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Product = () => {
  const [page, setPage] = useState(0); // Current page number
  const [rowsPerPage, setRowsPerPage] = useState(5); //
  const [products, setProducts] = useState([]);
  const [available, setAvailable] = useState("");

  const deleteProduct = async (id) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}${API_ENDPOINTS.deleteProduct}/${id}`
      );
      if (response.data.statusCode === 0) {
        console.log("Delete product is unsuccessfull");
      }
      toast.success("Product deleted successfully")
      setProducts(prevData =>
        prevData.filter(product => product._id !== id)
      );
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };
  const updateProductStatus = async (product) => {
    try {
      console.log(product)
      const newStatus = product.status === "Enabled" ? "Disabled" : "Enabled";

      const response = await axios.put(
        `${BASE_URL}${API_ENDPOINTS.updateProduct}/${product._id}`, {
        status: newStatus
      }
      );
      if (response.data.successCode === 1) {
        console.log("Product Status is updated successfully");
        setProducts(prevProducts =>
          prevProducts.map(p =>
            p._id === product._id ? { ...p, status: newStatus } : p
          )
        );
      }
      else {
        console.error("Failed to update product status");
      }

    } catch (error) {
      console.error("Error updating status of product:", error);
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}${API_ENDPOINTS.getAllProducts}`
        );

        if (response.data.statusCode === 0) {
          console.log("Fetching products is unsuccessfull");
        }
        setProducts(response.data.result);

      } catch (error) {
        console.error("Error fetching products data:", error);
      }
    };

    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset page number when rows per page changes
  };
  const pagenatedProducts = products.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "95%",
        }}
      >
        <div
          style={{
            fontWeight: "600",
            fontSize: "1.5rem",
            margin: "auto 20px",
            marginLeft: "75px",
          }}
        >
          Products
        </div>
        <NavLink to="/addProduct" style={{ textDecoration: "none" }}>
          <button className="btn-pay" type="button">
            New Product
          </button>
        </NavLink>
      </div>

      <TableContainer
        component={Paper}
        style={{
          width: "90%",
          margin: "auto",
          marginTop: "20px",
          backgroundColor: "#fff",
        }}
      >
        <Table aria-label="sales table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "600" }}>Product ID</TableCell>
              <TableCell style={{ fontWeight: "600" }}>Product Name</TableCell>
              <TableCell style={{ fontWeight: "600" }}>Product Price</TableCell>
              <TableCell style={{ fontWeight: "600" }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pagenatedProducts.map(c => (
              <TableRow key={c._id}>
                <TableCell style={{ color: c.status === 'Disabled' ? 'red' : '' }}>{c._id}</TableCell>

                <TableCell style={{ color: c.status === 'Disabled' ? 'red' : '' }}>{c.productName}</TableCell>
                <TableCell style={{ color: c.status === 'Disabled' ? 'red' : '' }}>{c.price}</TableCell>
                <TableCell onClick={() => updateProductStatus(c)} style={{ color: c.status === 'Disabled' ? 'red' : 'green', fontWeight: "bold", cursor: "pointer" }} >{c.status}</TableCell>
                <TableCell style={{ fontWeight: 'bold', color: 'red', cursor: 'pointer' }} onClick={() => deleteProduct(c._id)}>Delete</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer >
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={products.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        style={{ margin: "20px auto" }}
      />
      <ToastContainer />
    </>
  );
};

export default Product;
